import { Module } from 'vuex';
import { ConfigState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { CONFIG_GETTERS } from './config.getters';
import { CONFIG_MUTATIONS } from './config.mutations';

export function getConfigModule(configState: ConfigState): Module<ConfigState, RootStoreState> {
  return {
    namespaced: true,
    mutations: CONFIG_MUTATIONS,
    getters: CONFIG_GETTERS,
    state: configState
  };
}
